import AsnDetailStore from "../../../stores/AsnDetailStore";
import AsnStore from "../../../stores/AsnStore";
import ProductItemStore from "../../../stores/ProductItemStore";
import {setElementsFromScope, swapClasses, insertValAndManageFocus, show, hide} from "../../../utilities/selectorHelpers";
import {unbindAll, extractElements} from "../../../utilities/viewHelpers";
import ProductView from "./ProductView";
import _ from "underscore";
import $ from "jquery";


const elementsMap = {
  productServicesOuter: ".product-services-outer"
};

export default function ProductLevelServicesView(el, {readOnly}={}){
  const self = this;
  const els = {};
  let productViews = [];

  self.init = function(){
    setElements();
    attachWidgets();
    bindElements();
    bindStores();
    renderChildren();
  };

  function setElements(){
    setElementsFromScope(els, elementsMap, el);
  }

  function attachWidgets(){

  }

  function bindElements(){

  }

  function renderChildren(){
    unbindAll(productViews);
    productViews = renderProductViews();
    els.productServicesOuter.html(extractElements(productViews));
  }

  function renderProductViews(){
    return _(groupBySku()).map((asnDetails, sku)=>{
      const productView = new ProductView(asnDetails, {readOnly});
      productView.init();
      return productView;
    });
  }

  function bindStores(){
    AsnStore.bindListener("asns:shipping_method_changed", renderChildren);
    AsnDetailStore.bindListener("asn_details:add", renderChildren);
    AsnDetailStore.bindListener("asn_details:remove", renderChildren);
    // we need a generic change event to be listenable here
    // because we are 'grouping' asn_details which inherently
    // requires a full children reRender
    AsnDetailStore.bindListener("asn_details:change", renderChildren);
  }

  function groupBySku(){
    return AsnDetailStore.groupBySku(getAsnDetails());
  }


  function getAsn(){
    return AsnStore.getAsnWithShippingMethod();
  }

  function getAsnDetails(){
    return AsnStore.getAsnDetails(getAsn());
  }
}



// WEBPACK FOOTER //
// ./src/pages/asns/ServicesTab/ProductLevelServicesView.js